import { performLogout, isAuthError } from "./auth-interceptor";
import { getTenantHeaderValue } from "./tenant";

const originalFetch = window.fetch;

window.fetch = function(url, options = {}) {
  let headers;
  
  if (options.headers instanceof Headers) {
    headers = new Headers(options.headers);
  } else if (options.headers) {
    headers = new Headers(options.headers);
  } else {
    headers = new Headers();
  }
  
  if (!headers.has('x-tenant-id')) {
    headers.set('x-tenant-id', getTenantHeaderValue());
    // headers.set('x-tenant-id', 'nuradiet.bizokitchen.com');
  }
  
  const modifiedOptions = {
    ...options,
    headers: headers
  };
  
  // Intercept the response to check for authentication errors
  return originalFetch.call(this, url, modifiedOptions)
    .then(response => {
      // Check if response indicates token expiration
      if (isAuthError(response)) {
        console.log('Authentication error detected. Logging out user.',response);
        performLogout();
        return Promise.reject(new Error('Authentication failed'));
      }
      return response;
    })
    .catch(error => {
      console.error('Fetch error:', error);
      // Re-throw the error after handling
      throw error;
    });
};

export default window.fetch;
